/*jslint node: true*/
var DataCache = require("./dataCache");
var dataCache = new DataCache();

module.exports = dataCache;



//////////////////
// WEBPACK FOOTER
// ./app/datacache/index.js
// module id = 488
// module chunks = 49